var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "product-insights",
      staticStyle: { "margin-bottom": "20px" }
    },
    [
      _c(
        "carousel",
        {
          attrs: { "per-page": 4, navigationEnabled: true, "mouse-drag": false }
        },
        [
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-8" }, [
                  _c("h3", [_vm._v("Activities Completed")]),
                  _c("h2", [_vm._v(_vm._s(_vm.activitiesCompletedNumber))])
                ]),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("h5", { staticClass: "brown_line" }, [
                    _vm._v(_vm._s(_vm.activitiesCompletedPercentage) + "%")
                  ])
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-8" }, [
                  _c("h3", [_vm._v("Activities With Issues")]),
                  _c("h2", [_vm._v(_vm._s(_vm.activitiesWithIssuesNumber))])
                ]),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("h5", [
                    _vm._v(_vm._s(_vm.activitiesWithIssuesPercentage) + "%")
                  ])
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-8" }, [
                  _c("h3", [_vm._v("Repeat Locations")]),
                  _c("h2")
                ]),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("h5", { staticClass: "brown_line" }, [
                    _vm._v(_vm._s(_vm.repeatLocations))
                  ])
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-8" }, [
                  _c("h3", [_vm._v("Buy Me $ Credit Consumed")])
                ]),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("h5", [_vm._v("$" + _vm._s(_vm.byMeCreditConsumed))])
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", [_vm._v("Average Lead Response Time")]),
                  _c("h2", [_vm._v(_vm._s(_vm.AverageLeadResponseTime))])
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", [_vm._v("Fastest Lead Response Time")]),
                  _c("h2", [_vm._v(_vm._s(_vm.FastestLeadResponseTime))])
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", [_vm._v("Trips Frequency")]),
                  _c("h2", [_vm._v(_vm._s(_vm.tripsFrequency))])
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", [_vm._v("Basket Size")]),
                  _c("h2", [_vm._v(_vm._s(_vm.basketSize))])
                ])
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }